<!-- eslint-disable -->
<template>
  <div class="page_box">
    <se-breadcrumb :itemData="breadData" showBottomBorder> </se-breadcrumb>
    <div class="title">
      <h2>
        {{ activityName}}
        <router-link
          class="text-btn-edit look-coupon"
          :to="`/management/fission/fission-campagin-add/${this.activityCode}`"
          >{{ $t("v210801.view-activity") }}</router-link
        >
      </h2>
    </div>
    <div class="analysis_box">
      <div class="analysis_item analysis_item_left">
        <div class="analysis_item_title">活动概况（不含新媒体数据）</div>
        <div class="analysis_chart_box">
          <div class="num_box">
            <div class="num_item">
              <div>
                <div>浏览人数</div>
                <div>{{ activityAnalysisDetail.browseCount }}</div>
              </div>
              <div class="num_share">
                <div>{{ activityAnalysisDetail.channelShareBrowseCount }}</div>
                <div>渠道分享浏览</div>
              </div>
              <div class="num_share">
                <div>{{ activityAnalysisDetail.userShareBrowseCount }}</div>
                <div>用户分享浏览</div>
              </div>
            </div>
            <div class="num_item">
              <div>
                <div>购买人数</div>
                <div>{{ activityAnalysisDetail.purchaseCount }}</div>
              </div>
              <div class="num_share">
                <div>{{ activityAnalysisDetail.channelSharePurchaseCount }}</div>
                <div>渠道分享购买</div>
              </div>
              <div class="num_share">
                <div>{{ activityAnalysisDetail.userSharePurchaseCount }}</div>
                <div>用户分享购买</div>
              </div>
            </div>
            <div class="num_item">
              <div>
                <div>使用人数</div>
                <div>{{ activityAnalysisDetail.useCount }}</div>
              </div>
              <div class="num_share">
                <div>{{ activityAnalysisDetail.channelShareUseCount }}</div>
                <div>渠道分享使用</div>
              </div>
              <div class="num_share">
                <div>{{ activityAnalysisDetail.userShareUseCount }}</div>
                <div>用户分享使用</div>
              </div>
            </div>
          </div>
          <div class="probability_box probability_1">
            <div>浏览-购买转化率</div>
            <div>{{ activityAnalysisDetail.browse2PurchaseRate }}%</div>
          </div>
          <div class="probability_box probability_2">
            <div>购买-使用转化率</div>
            <div>{{ activityAnalysisDetail.purchase2UseRate }}%</div>
          </div>
          <div class="probability_box probability_3">
            <div>浏览-使用转化率</div>
            <div>{{ activityAnalysisDetail.browse2UseRate }}%</div>
          </div>
        </div>
      </div>
      <div class="analysis_item_right">
        <div class="analysis_item analysis_item_right1">
          <div class="analysis_item_title">总GMV</div>
          <div class="analysis_item_right1_content">
            <div>¥{{ activityAnalysisDetail.totalGmv }}</div>
          </div>
        </div>
        <div class="analysis_item analysis_item_right2">
          <div class="analysis_item_title">新媒体兑换数据</div>
          <div class="analysis_item_right2_content">
            <div class="item">
              <div>{{ activityAnalysisDetail.newMediaTotalCount }}</div>
              <div>兑换总单数</div>
            </div>
            <div class="down">
              <div class="item" v-for="(item,index) in activityAnalysisDetail.newMediaChannelCountList" :key="index">
                <div>{{ item.count }}</div>
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data_table_box">
      <my-table ref="list" :data="tableList" @page="pageHandler" :listLoading="listLoading">
        <!-- 表格数据搜索 -->
        <template #header="params">
          <el-tabs v-model="tabName" @tab-click="(e)=>tabChange(e, params, 1)">
            <el-tab-pane label="活动参与明细" name="1"></el-tab-pane>
            <el-tab-pane label="渠道明细" name="2"></el-tab-pane>
            <el-tab-pane label="用户裂变明细" name="3"></el-tab-pane>
          </el-tabs>
          <div class="search_box">
            <el-row :gutter="10">
              <el-col :span="6" v-if="tabName==1||tabName==3">
                <el-input placeholder="请输入手机号" v-model="searchData.customerMobile" class="input-with-select"></el-input>
              </el-col>
              <el-col :span="8">
                <el-date-picker
                  style="width: 100%;"
                  v-model="activeDateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="pickerDateChange"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-button @click="resetSearchData">重置</el-button>
                <el-button ref="searchButton" @click="pageHandler(params, 1)" type="primary">查询</el-button>
              </el-col>
            </el-row>
          </div>
        </template>

        <span v-for="(item, index) in tableData" :key="index">
          <el-table-column v-if="item.prop == 'customerMobile'" :label="item.label" :prop="item.prop" :min-width="item.width">
            <template slot-scope="scope">
              <el-button type="text" @click="handleUserView(scope.row)" class="blue-btn">{{ scope.row.customerMobile }}</el-button>
            </template>
          </el-table-column>

          <el-table-column v-else-if="item.clickable" :label="item.label" :prop="item.prop" :min-width="item.width">
            <template slot-scope="scope">
              <el-button type="text" @click="showDetailDialog(item.prop, scope.row)" class="blue-btn">{{ scope.row[item.prop] }}</el-button>
            </template>
          </el-table-column>

          <el-table-column v-else :label="item.label" :prop="item.prop" :min-width="item.width"></el-table-column>
        </span>
        <el-table-column label="操作" fixed="right" prop="" width="100">
          <template slot-scope="scope">
             <el-button v-if="tabName == 1 && scope.row.canRefund ==1 " class="handle_btn" type="text" size="mini" @click="returnCard(scope.row)">退单</el-button>
            <!-- <el-button v-if="tabName == 2 || tabName == 3" class="handle_btn" type="text" size="mini" @click="tableHandle(2, scope.row)">查看</el-button> -->
          </template>
        </el-table-column>
      </my-table>
    </div>
    <el-dialog
      title="退卡"
      :visible.sync="cardDialogVisible"
      width="70%"
      :before-close="cardHandleClose">
      <div class="table_box">
        <div class="table_title">套餐卡</div>
        <el-table
          v-for="(card, index) in orderCardData"
          :key="index"
          :data="card.serviceList"
          border
          style="width: 100%">
          <el-table-column
            prop="serviceName"
            label="项目名称"
            width="180">
          </el-table-column>
          <el-table-column
            label="剩余次数/总次数"
            width="180">
            <template slot-scope="scope">{{ scope.row.residueCount }}/{{ scope.row.totalCount }}</template>
          </el-table-column>
          <el-table-column
            prop="carryingBalance"
            label="账面余额（元）">
          </el-table-column>
        </el-table>
      </div>
<!--      <div class="table_box">-->
<!--        <div class="table_title">优惠券</div>-->
<!--        <el-table-->
<!--          :data="orderCouponData"-->
<!--          border-->
<!--          style="width: 100%">-->
<!--          <el-table-column-->
<!--            prop="date"-->
<!--            label="优惠券名称">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="name"-->
<!--            label="优惠券状态"-->
<!--            width="180">-->
<!--          </el-table-column>-->
<!--        </el-table>-->
<!--      </div>-->
      <div class="refund-form">
        <el-form
            label-position="right"
            :rules="refundFormRule"
            label-width="auto"
            ref="refundForm"
            :model="refundForm"
        >
          <el-form-item label="实际退款金额" prop="returnAmount">
            <se-input-unit unitName="元" v-model="refundForm.returnAmount"></se-input-unit>
          </el-form-item>
          <el-form-item label="退单原因" prop="returnRemark">
            <el-input unitName="元" v-model="refundForm.returnRemark"></el-input>
          </el-form-item>
          <el-form-item label="支付方式" prop="returnMethod">
            <el-select v-model="refundForm.returnMethod">
              <el-option
                  v-for="item in payWayList"
                  :label="item.payMethodName"
                  :value="item.payMethodCode"
                  :key="item.payMethodCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="tips"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cardDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="returnCardConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 用户裂变明细弹窗 -->
    <el-dialog
      :title="detailDialogTitle"
      :visible.sync="detailDialogVisible"
      width="70%"
      :before-close="detailDialogClose">
      <my-table ref="detailList" :data="detailTableList" @page="detailPageHandler" :listLoading="detailListLoading">
        <el-table-column
          v-for="(item, index) in detailTableData"
          :key="index"
          :label="item.label"
          :prop="item.prop"
          :min-width="item.width">
        </el-table-column>
      </my-table>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import t from "@common/src/i18n/t";
import {namespace} from "vuex-class";
const marketing = namespace("marketing");
import { emptyToLine, splitThousands } from "@/utils/common";


export default {
  // emptyToLine = emptyToLine;
  // splitThousands = splitThousands;
  //import引入的组件需要注入到对象中才能使用
  components: {},
    data() {
    //这里存放数据
      return {
        activityCode: '',                                   //活动code
        activityName: '',                                   //活动名称
        tabName: '1',                                       //列表标签页
        searchData: {                                       //查询数据
          customerMobile: '',
          dateStart: '',
          dateEnd: ''
        },
        tableList: [{}],                                      //列表数据
        listLoading: false,                                 //列表loading
        // 用户裂变明细弹窗相关数据
        detailDialogVisible: false,                         //详情弹窗状态
        detailDialogTitle: '',                              //详情弹窗标题
        detailTableList: [],                                //详情表格数据
        detailListLoading: false,                           //详情列表loading
        detailTableData: [],                                //详情表格字段
        detailSearchData: {                                 //详情查询数据
          dateStart: '',
          dateEnd: '',
          customerName: '',
          customerMobile: ''
        },
        currentDetailType: '',                              //当前详情类型
        currentRowData: null,                               //当前行数据
        activityDetailData: [                               //活动参与明细展示字段
          { label: "订单号", width: 160, prop: "orderNo" },
          { label: "用户姓名", width: 100, prop: "customerName" },
          { label: "手机号", width: 100, prop: "customerMobile" },
          { label: "购买产品", width: 150, prop: "skusName" },
          { label: "金额", width: 100, prop: "paymentAmount" },
          { label: "购买时间", width: 180, prop: "createTime" },
          { label: "发放类型", width: 100, prop: "issueTypeName" },
          { label: "发放渠道", width: 100, prop: "channel" },
          { label: "发放备注", width: 100, prop: "remark" }
        ],
        activityDetailList: [{},{},{}],                           //活动参与明细table列表
        channelDetailData: [                                //渠道明细展示字段
          { label: "时间", width: 120, prop: "date" },
          { label: "渠道类型", width: 100, prop: "channel" },
          { label: "子类型", width: 100, prop: "linkName" },
          { label: "分享浏览次数", width: 100, prop: "shareBrowsePv" },
          { label: "分享浏览人数", width: 100, prop: "shareBrowseUv" },
          { label: "成交", width: 100, prop: "purchaseCount" },
          // { label: "总奖励金额", width: 100, prop: "" },
        ],
        channelDetailList: [{},{},{}],                            //渠道明细table列表
        userDetailData: [                                   //用户裂变明细展示字段
          { label: "时间", width: 120, prop: "date" },
          { label: "用户姓名", width: 100, prop: "customerName" },
          { label: "手机号", width: 100, prop: "customerMobile" },
          { label: "分享次数", width: 100, prop: "shareCount" },
          { label: "分享浏览次数", width: 100, prop: "shareBrowsePv", clickable: true },
          { label: "分享浏览人数", width: 100, prop: "shareBrowseUv", clickable: true },
          { label: "成交", width: 100, prop: "purchaseCount", clickable: true },
          // { label: "总奖励金额", width: 100, prop: "" },
        ],
        userDetailList: [{},{},{}],                               //用户裂变明细table列表
        cardDialogVisible: false,                           //退卡弹窗状态
        activityAnalysisDetail: {},                     //活动概况数据
        activeDateTime: [],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        orderCardData: [], // 购买订单的卡券信息
        orderCouponData: [],  //购买订单的优惠券信息

        refundFormRule: {
          returnAmount: [
            { required: true, message: "请输入实际退款金额", trigger: "blur" },
            { validator: this.checkPrice, trigger: "blur" }
          ],
          returnRemark: { required: true, message: "请输入退款原因", trigger: "blur" },
          returnMethod: { required: true, message: "请选择支付方式", trigger: "change" }
        },
        refundForm: {
          orderNo: "",
          returnAmount: "",
          returnMethod: "",
          returnRemark: ""
        },
        payWayList: [{
          payMethodName: "微信支付",
          payMethodCode: "3",
        }]

      };
    },
  //监听属性 类似于data概念
  computed: {
    breadData() {
      return [
        { name: t("v210801.platform-fission-activity"), path: "/management/fission/fission-campagin" },
        {
          name: t("v210801.activity-data-analysis")
        }
      ];
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 显示详情弹窗
    showDetailDialog(type, row) {
      this.currentRowData = row;
      this.currentDetailType = type;

      // 根据类型设置弹窗标题和表格字段
      switch(type) {
        case 'shareBrowsePv':
          this.detailDialogTitle = '分享浏览次数详情';
          this.detailTableData = [
            { label: "分享编号", width: 100, prop: "shareCode" },
            { label: "分享人手机号", width: 120, prop: "sharerMobile" },
            { label: "浏览人手机号", width: 100, prop: "viewerMobile" },
            { label: "浏览时间", width: 100, prop: "createTime" },
            { label: "浏览标识", width: 100, prop: "identifier" },
            { label: "浏览来源", width: 100, prop: "browseFrom" },
          ];
          break;
        case 'shareBrowseUv':
          this.detailDialogTitle = '分享浏览人数详情';
          this.detailTableData = [
            { label: "浏览人手机号", width: 120, prop: "viewerMobile" },
            { label: "浏览总次数", width: 100, prop: "views" },
            { label: "最近浏览时间", width: 120, prop: "lastBrowseTime" },
          ];
          break;
        case 'purchaseCount':
          this.detailDialogTitle = '成交详情';
          this.detailTableData = [
            { label: "订单号", width: 120, prop: "orderNo" },
            { label: "用户姓名", width: 100, prop: "customerName" },
            { label: "手机号", width: 120, prop: "customerMobile" },
            { label: "订单号", width: 160, prop: "orderNo" },
            { label: "金额", width: 100, prop: "paymentAmount" },
            { label: "购买时间", width: 180, prop: "createTime" },
          ];
          break;
        default:
          return;
      }

      // 显示弹窗并加载数据
      this.detailDialogVisible = true;
      this.$refs.detailList.pageNum = 1;
      this.$refs.detailList.init();
    },

    // 详情弹窗分页处理
    detailPageHandler(params,num) {
      // 设置查询参数
      const searchData = {
        ...this.detailSearchData,
        dateStart: this.searchData.dateStart,
        dateEnd: this.searchData.dateEnd,
        customerMobile: this.currentRowData.customerMobile
      };

      // 根据类型调用不同的API
      switch(this.currentDetailType) {
        case 'shareBrowsePv':
          this.getShareBrowsePvDetail(params,num ? num : params.pageNum, params.pageSize, searchData);
          break;
        case 'shareBrowseUv':
          this.getShareBrowseUvDetail(params, num ? num : params.pageNum, params.pageSize, searchData);
          break;
        case 'purchaseCount':
          this.getPurchaseCountDetail(params, num ? num : params.pageNum, params.pageSize, searchData);
          break;
      }
    },

    // 获取分享浏览次数详情
    async getShareBrowsePvDetail(params, pageNum, pageSize, searchData) {
      this.detailListLoading = true;
      try {
        // 调用实际的API获取分享浏览次数详情
        const res = await this.$store.dispatch('marketing/getShareViewsPageList', {
          ...searchData,
          activityCode: this.activityCode,
          shareDate: this.currentRowData.date,
          pageNum,
          pageSize
        });
        this.detailTableList = res.data.list;
        this.$refs.detailList.render(res.data.total);
      } catch (error) {
        console.error('获取分享浏览次数详情失败:', error);
        this.$message.error('获取分享浏览次数详情失败');
      } finally {
        this.detailListLoading = false;
      }
    },

    // 获取分享浏览人数详情
    async getShareBrowseUvDetail(params, pageNum, pageSize, searchData) {
      this.detailListLoading = true;
      try {
        // 调用实际的API获取分享浏览人数详情
        const res = await this.$store.dispatch('marketing/getShareBrowsePeoplePageList', {
          ...searchData,
          activityCode: this.activityCode,
          shareDate: this.currentRowData.date,
          pageNum,
          pageSize
        });

        this.detailTableList = res.data.list;
        this.$refs.detailList.render(res.data.total);
      } catch (error) {
        console.error('获取分享浏览人数详情失败:', error);
        this.$message.error('获取分享浏览人数详情失败');
      } finally {
        this.detailListLoading = false;
      }
    },

    // 获取成交详情
    async getPurchaseCountDetail(params, pageNum, pageSize, searchData) {
      this.detailListLoading = true;
      try {
        // 调用实际的API获取成交详情
        const res = await this.$store.dispatch('marketing/getFissionExecutionOrderPageList', {
          ...searchData,
          activityCode: this.activityCode,
          shareDate: this.currentRowData.date,
          pageNum,
          pageSize
        });
        this.detailTableList =  res.data.list;
        this.$refs.detailList.render(res.data.total);
      } catch (error) {
        console.error('获取成交详情失败:', error);
        this.$message.error('获取成交详情失败');
      } finally {
        this.detailListLoading = false;
      }
    },

    // 详情弹窗关闭
    detailDialogClose() {
      this.detailDialogVisible = false;
      this.detailTableList = [];
      this.detailTableData = [];
      this.currentDetailType = '';
      this.currentRowData = null;
    },

    pageHandler(params, num) {
      switch (this.tabName) {
        case '1':           //活动参与明细
          this.getAnalysisDetailList(params, num ? num : params.pageNum, params.pageSize);
          break;
        case '2':           //渠道明细
          this.getAnalysisChannelList(params, num ? num : params.pageNum, params.pageSize);
          break;
        case '3':           //用户裂变明细
          this.getAnalysisShareList(params, num ? num : params.pageNum, params.pageSize);
          break;

        default:
          break;
      }
    },
    // 表格内操作
    tableHandle(type, row) {

    },
    // 重置搜索数据
    resetSearchData(e) {
      this.searchData = {                                       //查询数据
        customerMobile: '',
        dateStart: '',
        dateEnd: ''
      }
      this.activeDateTime = [];
    },
    // 退卡
    returnCard(row){
      this.refundForm.orderNo = row.orderNo;
      this.orderCardData = [];
      this.getAnalysisDetail(row.orderNo);
      this.cardDialogVisible = true;
    },
    returnCardConfirm(){
      (this.$refs.refundForm).validate(valid => {
        if (valid) {
          this.$store.dispatch('marketing/newAnalysisRefund',{
            ...this.refundForm
          }).then(res => {
            this.$message.success("退单成功");
            this.$emit("returnCardSuccess");
            this.$refs.searchButton.$el.click();
            this.cardDialogVisible = false
          })
        }
      });
    },
    // 退卡弹窗关闭
    cardHandleClose(){
      this.cardDialogVisible = false;
    },
    // 标签点击
    tabChange(e, params, num){
      this.searchData = {                                       //查询数据
        customerMobile: '',
        dateStart: '',
        dateEnd: ''
      }
      this.activeDateTime = [];
      switch (e.name) {
        case '1':           //活动参与明细
          this.getAnalysisDetailList(params, num ? num : params.pageNum, params.pageSize).then(()=>{
            this.tabName = e.name;
          });
          break;
        case '2':           //渠道明细
          this.getAnalysisChannelList(params, num ? num : params.pageNum, params.pageSize).then(()=>{
            this.tabName = e.name;
          });;
          break;
        case '3':           //用户裂变明细
          this.getAnalysisShareList(params, num ? num : params.pageNum, params.pageSize).then(()=>{
            this.tabName = e.name;
          });;
          break;

        default:
          break;
      }
    },
    // 时间范围选择
    pickerDateChange(e){
      this.searchData.dateStart = e[0];
      this.searchData.dateEnd = e[1];
    },


    // 获取数据概览
    getActivityAnalysis(){
      this.$store.dispatch('marketing/newActivityAnalysis',{
        activityCode: this.activityCode
      }).then(res => {
        console.log(res)
        this.activityAnalysisDetail = res.data;
      })
    },
    // 获取活动参与明细列表
    async getAnalysisDetailList(params,pageNum,pageSize){
      await this.$store.dispatch('marketing/newAnalysisDetailList',{
        ...this.searchData,
        activityCode: this.activityCode,
        pageNum,
        pageSize
      }).then(res => {
        console.log(res)
        this.tableData = this.activityDetailData;
        this.tableList = res.data.list;
        params.render(res.data.total);
      })
    },
    // 获取活动参与明细
    async getAnalysisDetail(orderNo){
      await this.$store.dispatch('marketing/newAnalysisDetail',{
        orderNo: orderNo
      }).then(res => {
        let cardSkuList = res.data.cardSkus;
        for (const item of cardSkuList) {
          this.queryCardDetail(item.cardCode);
        }
        console.log(this.orderCardData)
      })
    },
    // 获取卡明细
    async queryCardDetail(cardCode){
      await this.$store.dispatch('marketing/queryCardDetail',{
        cardCode: cardCode
      }).then(res => {
        console.log(res)
        this.orderCardData.push(res.data)
      })
    },
    // 获取渠道明细列表
    async getAnalysisChannelList(params,pageNum,pageSize){
      await this.$store.dispatch('marketing/newAnalysisChannelList',{
        ...this.searchData,
        activityCode: this.activityCode,
        pageNum,
        pageSize
      }).then(res => {
        console.log(res)
        this.tableData = this.channelDetailData;
        this.tableList = res.data.list;
        params.render(res.data.total);
      })
    },
    // 获取用户裂变明细列表
    async getAnalysisShareList(params,pageNum,pageSize){
      await this.$store.dispatch('marketing/newAnalysisShareList',{
        ...this.searchData,
        activityCode: this.activityCode,
        pageNum,
        pageSize
      }).then(res => {
        console.log(res)
        this.tableData = this.userDetailData;
        this.tableList = res.data.list;
        params.render(res.data.total);
      })
    },

    handleUserView(row) {
      let { href } = this.$router.resolve({
        path: `/customer/customer-view/${row.customerMobile}`
      });
      window.open(href, "_blank");
    }

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // 获取活动code
    this.activityCode = this.$route.params.id;
    this.activityName = this.$route.query.activityName;
    // 默认展示tab和列表
    this.tabName = '1';
    this.tableData = this.activityDetailData;
    // this.tableList = this.activityDetailList;
    // 获取活动概览数据
    this.getActivityAnalysis();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
}
</script>
<style lang="scss" scoped>
  //@import url(); 引入公共css类
  .page_box{
    padding: 0 20px 20px;
    box-sizing: border-box;
    .title {
      margin: 24px 0 20px 0;
      h2 {
        .look-coupon {
          color: $link-color;
          font-size: 14px;
          font-weight: 200;
          margin-left: 16px;
        }
      }
    }
    .analysis_box{
      min-width: 1300px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .analysis_item{
        background: #fff;
        .analysis_item_title{
          padding: 0px 15px;
          height: 40px;
          line-height: 40px;
          font-weight: bold;
          font-size: 16px;
          border-bottom: 1px solid #dfe4ed;
        }
      }
      .analysis_item_left{
        width: 902px;
        height: 330px;
        margin-right: 10px;
        .analysis_chart_box{
          width: 802px;
          height: 244px;
          margin: 20px auto;
          background: url(../../../assets/img/campain-analysis-bg.png) no-repeat;
          background-size: 100% 100%;
          position: relative;
          .num_box{
            height: 100%;
            position: absolute;
            left: 290px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            .num_item{
              display: flex;
              align-items: center;
              text-align: center;
              .num_share>:last-child{
                color: #8c8c8c;
              }
            }
            .num_item>div{
              width: 100px;
            }
            .num_item >div:first-child{
              margin-right: 165px;
              color: #fff;
              font-weight: bold;
              font-size: 16px;
            }
          }
          .probability_box{
            position: absolute;
            text-align: center;
            >div:last-child{
              font-size: 15px;
              font-weight: bold;
            }
            >div:first-child{
              color: #8c8c8c;
            }
          }
          .probability_1{
            left: 90px;
            top: 55px;
          }
          .probability_2{
            left: 90px;
            bottom: 65px;
          }
          .probability_3{
            top: 95px;
            left: -30px;
          }
        }
      }
      .analysis_item_right{
        flex: 1;
        height: 330px;
        .analysis_item_right1{
          height: 120px;
          margin-bottom: 10px;
          .analysis_item_right1_content{
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            font-weight: bold;
            color: #333;
          }
        }
        .analysis_item_right2{
          height: 200px;
          .analysis_item_right2_content{
            height: 160px;
            margin-top: 30px;
            color: #333;
            .item{
              text-align: center;
              font-size: 15px;
              font-weight: bold;
            }
            .down{
              margin-top: 20px;
              display: flex;
              align-items: center;
              justify-content: space-around;
              .item{
                font-size: 13px;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
    .data_table_box{
      min-width: 1300px;
      background: #fff;
      margin-top: 10px;
      .search_box{
        padding: 10px 20px;
        margin-bottom: -20px;
      }
    }
  }
  .table_box{
    margin-bottom: 20px;
    .table_title{
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
  ::v-deep .el-tabs__nav-wrap{
    padding-left: 15px !important;
  }
  .blue-btn {
    color: #409EFF;
  }
</style>
